module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#frontmatter-02",
      "id": "frontmatter02"
    }
  }, [_c('span', {
    staticClass: "gray1"
  }, [_vm._v("USING THIS BOOK")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The two introductory chapters, "), _c('i', [_vm._v("In the Garden")]), _vm._v(" and "), _c('i', [_vm._v("In the Kitchen")]), _vm._v(", contain all the general information you will need to get started. Terms and techniques used in the Grow and Bake pages such as ‘sow thinly’ or ‘make the pastry’ are explained too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Each crop has its own Grow page, and each recipe a Bake page. First come the larger cakes, divided by season: Spring & Summer Cakes, and Autumn & Winter Cakes. Such an arrangement should not deter you from delving into an out-of-season chapter if you have the appropriate fruit or vegetables to hand. Afternoon Tea contains most of the smaller bakes suitable for that occasion, while Puddings has dessert cakes, tarts and cheesecake for every time of year. Finally Savoury Bakes such as simple breads and tarts offer the chance of serving a home-grown main course as well.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3v"
  }, [_vm._v("A NOTE ON THE RECIPES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When weighing out ingredients, use the metric or the imperial measures – never mix the two systems.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("See "), _c('i', [_c('span', {
    attrs: {
      "href": "#/frontmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Kitchen")])]), _vm._v(" for more information but unless otherwise stated:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_c('a', {
    attrs: {
      "id": "pg11head1b"
    }
  }), _vm._v("Oven temperatures in degrees Celsius/Fahrenheit are for fan ovens. Add 20°C/50°F if you do not have a fan oven.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Vegetables and fruit are washed, scrubbed and topped-and-tailed as appropriate.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("All ingredients, especially butter and eggs, are used at room temperature.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_c('a', {
    attrs: {
      "id": "pg11head1a"
    }
  }), _vm._v("Eggs are medium size.")])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "h3v"
  }, [_c('a', {
    attrs: {
      "id": "pg11head1"
    }
  }), _vm._v("BAKING WITH ALLERGIES & INTOLERANCES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following recipes are wheat-free (WF), gluten-free (GF), dairy-free (DF) or dairy-free without the frosting:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Beetroot cake (see "), _c('span', {
    attrs: {
      "href": "#/chapter01#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") DF;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Blackcurrant mini-pavlovas (see "), _c('span', {
    attrs: {
      "href": "#/chapter03#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") WF/GF;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Carrot & almond cake (see "), _c('span', {
    attrs: {
      "href": "#/chapter01#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") WF/GF/DF without frosting;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Chocolate & raspberry bean cake (see "), _c('span', {
    attrs: {
      "href": "#/chapter01#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") WF/GF/DF;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Flower meringues (see "), _c('span', {
    attrs: {
      "href": "#/chapter03#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") WF/GF/DF;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Hazelnut & rosemary pavlova (see "), _c('span', {
    attrs: {
      "href": "#/chapter04#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") WF/GF;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Pea cheesecake (see "), _c('span', {
    attrs: {
      "href": "#/chapter05#pg160head1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") WF;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Poppy seed flower-pot bread (see "), _c('span', {
    attrs: {
      "href": "#/chapter05#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") DF;")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "bullf"
  }, [_vm._v("•")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "bull1f"
  }, [_vm._v("Tomato cupcakes (see "), _c('span', {
    attrs: {
      "href": "#/chapter03#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(") DF without frosting.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1v"
  }, [_vm._v("All the recipes involving pastry can be made gluten-free, see "), _c('span', {
    attrs: {
      "href": "#/frontmatter04#pg38head1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a65bbfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 72
// module chunks = 0